import React from 'react';

export const RATES = [
    {
        name: '1 Man Team',
        xLabels: [''],
        yLabels: ['1 - 250 miles', '250+ miles'],
        buckets: [
            ...[0, 1].map((idx) => {
                return ['ONE_MAN_FLAT_RATE'].map((type, col) => {
                    return {
                        type,
                        bucket: idx,
                    };
                });
            }),
        ],
    },
    {
        name: '2 Man Team',
        xLabels: [''],
        yLabels: ['1 - 300 miles', '300+ miles'],
        buckets: [
            ...[0, 1].map((idx) => {
                return ['TWO_MAN_FLAT_RATE'].map((type, col) => {
                    return {
                        type,
                        bucket: idx,
                    };
                });
            }),
        ],
    },
];

export const DEFAULT_RATES = {
    ONE_MAN_FLAT_RATE: [
        { min: 0, max: 250 },
        { min: 250, max: 'infinity' },
    ],
    TWO_MAN_FLAT_RATE: [
        { min: 0, max: 300 },
        { min: 300, max: 'infinity' },
    ],
    FUEL_PRICE_MODIFIER: [{ min: 0, max: 'infinity' }],
    FUEL_PRICE_MODIFIER_BASE: [{ min: 0, max: 'infinity' }],
    FUEL_PRICE_BY_ITEM: [{ min: 0, max: 'infinity' }],
    FUEL_PRICE_BY_MILE: [{ min: 0, max: 'infinity' }],
    FUEL_PRICE_BY_CABINET: [{ min: 0, max: 'infinity' }],
};

export const ACCESSORIALS = [
    {
        label: 'Fuel Modifier',
        type: 'FUEL_PRICE_MODIFIER',
        adornment: '%',
        isPercentage: true,
        decorator: 'of subtotal',
    },
];

export const RenderDefaultAccessorial = ({
    DefaultAccessorial,
    MaxSplitAccessorial,
    accessorial,
    rates,
    errors,
    callbacks,
}) => {
    switch (accessorial.type) {
        case 'FUEL_PRICE_MODIFIER':
        case 'FUEL_PRICE_FLAT':
        case 'FUEL_PRICE_MPG':
        case 'FUEL_PRICE_BY_ITEM':
        case 'FUEL_PRICE_BY_MILE':
        case 'FUEL_PRICE_BY_CABINET':
            return null;
        default: {
            return (
                <DefaultAccessorial
                    key={accessorial.type}
                    {...accessorial}
                    rates={rates}
                    errors={errors}
                    callbacks={callbacks}
                />
            );
        }
    }
};
